// export * from '../api-mock';
export * from './router';
export * from './fetch-middleware';

export function mergeOptions(options = {}) {
  return Object.values(options).reduce((arr, val) => [...arr, ...val], []);
}
